module.exports = {
  MotionScene: {
    PluginName: "Motion Scene",
  },
};
